import { Suspense } from 'react';

import clsx from 'clsx';

import { AdditionalForm } from './AdditionalForm';
import { Addresses } from './Addresses';
import { Buttons } from './Buttons';
import {
  animationClassName,
  focusWithinClassName,
  gapClassName,
  groupClassName,
} from './classNames';
import { Dates } from './Dates';
import { DeclaredValue } from './DeclaredValue';
import { useFormDataContext } from './FormDataContext';
import { Lines } from './Lines';
import { LoadTypes } from './LoadTypes';
import { Modality } from './Modality';
import { OrderNumberAndCoupon } from './OrderAndCoupon';
import { Packages } from './Packages';
import { ServicesQuantity } from './ServicesQuantity';
import { ServiceType } from './ServiceType';
import { OthersTitle, ServiceTitle, VehiclesTitle } from './Titles';
import { TransportConditions } from './TransportConditions';
import { Vehicle } from './Vehicle';
import { WaresDescription } from './WaresDescription';

export function CommonForm({
  operations,
}: {
  modal?: boolean;
  operations?: boolean;
}) {
  const { user } = useFormDataContext();
  if (operations && !user) return null;
  return (
    <>
      <Suspense>
        <Lines />
      </Suspense>
      <div
        className={clsx(
          'flex flex-col',
          groupClassName,
          gapClassName,
          animationClassName,
          focusWithinClassName
        )}
      >
        <Suspense>
          <ServiceTitle>
            <ServiceType />
            <Modality />
            <LoadTypes />
          </ServiceTitle>
        </Suspense>
      </div>
      <Suspense>
        <Addresses />
      </Suspense>
      <Suspense>
        <Packages />
      </Suspense>
      <div
        className={clsx(
          'flex flex-col',
          groupClassName,
          gapClassName,
          animationClassName,
          focusWithinClassName
        )}
      >
        <Suspense>
          <VehiclesTitle />
          <AdditionalForm />
          <Vehicle />
        </Suspense>
      </div>
      <Suspense>
        <Dates />
      </Suspense>

      <Suspense>
        <OthersTitle>
          <WaresDescription />
          <DeclaredValue />
          <ServicesQuantity />
          <TransportConditions />
          <OrderNumberAndCoupon />
        </OthersTitle>
      </Suspense>

      <Suspense>
        <Buttons />
      </Suspense>
    </>
  );
}

export const parentClassName =
  'mx-0.5 flex max-w-full gap-x-4 gap-y-7 empty:hidden flex-col';
